import React, { useMemo } from "react";

// Material UI Imports
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

// Type Imports
import { ISelectOption } from "@pulse-ui/types/components/DropdownInput";

const DropdownInput = ({
  name,
  value,
  label,
  onChange,
  disabled,
  options,
  formInput,
  containerClassNames,
  omitEmptyOption,
  selectSx,
}: {
  name: string;
  value: string | null;
  label: string;
  onChange: (e: any) => void;
  disabled: boolean;
  options: ISelectOption[];
  formInput: boolean;
  containerClassNames: string;
  omitEmptyOption?: boolean;
  selectSx?: Record<string, any>;
}) => {
  const selectOptions = useMemo(() => {
    return options.map((option) => (
      <MenuItem
        key={option.value}
        value={option.value}
        sx={{ color: "#e8eaef !important" }}
      >
        {option.label}
      </MenuItem>
    ));
  }, [options]);

  return (
    <div
      className={`${
        formInput ? "form-dropdown-input-container" : "dropdown-input-container"
      } ${containerClassNames}`}
    >
      <FormControl
        variant="standard"
        sx={{ m: 1, minWidth: 220 }}
        className="dropdown-input-select-form"
      >
        <InputLabel
          id="dropdown-input-select-label"
          className={`dropdown-input-select-label ${
            disabled && "dropdown-input-select-label-disabled"
          }`}
          disabled={disabled}
        >
          {label}
        </InputLabel>
        <Select
          name={name}
          labelId="dropdown-input-select-label"
          id="dropdown-input-select"
          value={value && value}
          onChange={onChange}
          label={label}
          disabled={disabled}
          sx={{
            ...selectSx,
            color: "#e8eaef",
            "& .MuiSelect-select": {
              color: "#e8eaef",
            },
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                backgroundColor: "#0c1835",
                "& .MuiMenuItem-root": {
                  color: "#e8eaef !important",
                },
                "& .MuiMenuItem-root.Mui-selected": {
                  backgroundColor: "#152b61",
                  color: "#e8eaef !important",
                },
                "& .MuiMenuItem-root.Mui-selected:hover": {
                  backgroundColor: "#1a3570",
                },
              },
            },
          }}
        >
          {!omitEmptyOption && (
            <MenuItem key="blank-key" value="" sx={{ color: "#e8eaef !important" }}>
              Select {label}
            </MenuItem>
          )}
          {selectOptions}
        </Select>
      </FormControl>
    </div>
  );
};

export default React.memo(DropdownInput);
